import * as angular from 'angular';

import CacheModel from './cache.model';
import CacheService from './cache.service';
import cacheInterceptor from './cache.interceptor.factory';

export default angular
  .module('CacheModule', [])
  .value('CacheModel', CacheModel)
  .service('CacheService', CacheService)
  .factory('cacheInterceptor', cacheInterceptor)
  .name;



// WEBPACK FOOTER //
// ./src/app/core/cache/cache.module.js